"use client";
import React, { useEffect } from "react";
import { DrinkTypeCardProps } from "@/interface";
import { Button } from "@/shared";
import { usePathname, useRouter } from "next/navigation";
import { useGlobalContext } from "@/contexts/AppContext";
import { formatURL } from "@/utils";
import Image from "next/image";
import styles from "./DrinkTypeCard.module.scss";
import useFetchCategoryProducts from "@/hooks/products/useFetchCategoryProducts";
import { useDispatch, useSelector } from "react-redux";
import { AppDispatch, AppState } from "@/store/configureStore";
import { revertBrand, setCategory, revertVariant, revertMinMax } from "@/store/slices/categoryProductSlice";

const DrinkTypeCard = ({ id, bg, icon, text, cardType = "home" }: DrinkTypeCardProps) => {
	const { theme, drinkType } = useGlobalContext();
	const route = usePathname();
	const router = useRouter();
	const category = useSelector((state: AppState) => state.categoryProduct.categoryName);

	const isAlcoholRoute = route.includes("/alcohol");
	const { fetchCategoryProducts, fetchBrands } = useFetchCategoryProducts();
	const dispatch = useDispatch<AppDispatch>();
	useEffect(() => {
		// Fetch products whenever the selected category changes

		if (category) {
			fetchCategoryProducts();
			fetchBrands(category);
		}
	}, [category]);

	return (
		<>
			{cardType === "home" ? (
				<div
					key={id}
					className={styles.card}
					data-type={cardType}
					style={{ background: `${bg}` }}
				>
					<div className={styles.btn_container}>
						<h3>{text}</h3>
						<Button
							onClick={() => {
								const categoryName = formatURL(text);
								dispatch(setCategory({
									name: text,
									icon: icon
								}));
								dispatch(revertBrand());
								dispatch(revertVariant());
								dispatch(revertMinMax())
								const targetUrl =
									drinkType === "alcohol"
										? `/alcohol/categories/${categoryName}`
										: `/categories/${categoryName}`;
								router.push(targetUrl);
							}}
							buttonType="transparent"
							className={styles.btn}
						>
							View all
						</Button>
					</div>

					<div data-route={route} className={styles.image}>
						<div className={styles.imageCont}>
							<Image alt="drink" src={icon} fill />
						</div>
					</div>
				</div>
			) : (
				<div
					key={id}
					className={styles.card}
					data-type={cardType}
					style={{ background: `${bg}` }}
					onClick={() =>
					{
						const categoryName = formatURL(text);
								dispatch(setCategory({
									name: text,
									icon: icon
								}));
								dispatch(revertBrand());
								dispatch(revertVariant());
								dispatch(revertMinMax())
								const targetUrl =
									drinkType === "alcohol"
										? `/alcohol/categories/${categoryName}`
										: `/categories/${categoryName}`;
								router.push(targetUrl);
					}
					}
				>
					<div className={styles.btn_container}>
						<h3>{text}</h3>
						<Button buttonType="transparent" className={styles.btn}>
							<p data-theme={theme}>View all</p>
						</Button>
					</div>

					<div data-route={route} className={styles.image}>
						<div className={styles.imageCont}>
							<Image alt="drink" src={icon} fill />
						</div>
					</div>
				</div>
			)}
		</>
	);
};

export default DrinkTypeCard;
